import 'zone.js';
import 'reflect-metadata';
import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './src/app.component.js';

if (location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
  enableProdMode();
}

bootstrapApplication(AppComponent)
  .catch(err => console.error(err));
